module.exports = __webpack_public_path__ + "static/saasvisitor1-5abab7a1425817d5a15eebf3e8477c8e.png";